import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useAvailableCertificates } from 'shared/hooks/use-available-certificates';
import { CertificateUploadFormValues } from '../types';
import { getAccreditationTypeOptions } from '../utils/utils';

export const useCertificateFormLogic = () => {
  const { t } = useTranslation('web-common');
  const { watch, setValue } = useFormContext<CertificateUploadFormValues>();
  const { accreditationType, certificate } = watch();
  const { data: certificates = [] } = useAvailableCertificates();

  const accreditationTypeOptions = getAccreditationTypeOptions(t);

  const isReceiptAccreditation = accreditationType === 'receipt';

  const filteredCertificates = isReceiptAccreditation
    ? certificates.filter((cert) => cert.canHaveReceipt)
    : certificates;

  const certificateItems = filteredCertificates.map((cert) => ({
    value: cert.id,
    label: cert.name,
  }));

  useEffect(() => {
    const certificateExists = filteredCertificates.some((cert) => cert.id === certificate);

    if (certificate && !certificateExists) {
      setValue('certificate', '', { shouldValidate: true });
    }
  }, [certificate, filteredCertificates, setValue]);

  return {
    accreditationTypeOptions,
    certificateItems,
  };
};
